<div class="elements-per-page-select" *ngIf="(state | async)[component].count !== null">
  <span i18n="@@ElementsPerPage">Elements per page: </span>
  <select (change)="handleChange($event)" class="uk-select uk-form-width-xsmall uk-form-small elements-per-page-select">
    <option [selected]="limit === 20">20</option>
    <option [selected]="limit === 40">40</option>
    <option [selected]="limit === 60">60</option>
    <option [selected]="limit === 80">80</option>
    <option [selected]="limit === 100">100</option>
  </select>
</div>
